$(function () {
    $(document).ready(function () {
        $('body').on('click', '.card-links-container a[href]', function () {
            orderViewModel.orderNowDashboardClick = true;
            orderViewModel.save();
            var buttonText = $(this).text().trim();
            analytics.cardListClick(buttonText);
        });
    });
});